import React from 'react';

const CandidatesIcon = ({
  size = 24,
  color = 'currentColor',
  sideColor,
  darkfy = false,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9699 14.4402C18.3399 14.6702 19.8499 14.4302 20.9099 13.7202C22.3199 12.7802 22.3199 11.2402 20.9099 10.3002C19.8399 9.59016 18.3099 9.35016 16.9399 9.59016"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99994 14.4402C5.62994 14.6702 4.11994 14.4302 3.05994 13.7202C1.64994 12.7802 1.64994 11.2402 3.05994 10.3002C4.12994 9.59016 5.65994 9.35016 7.02994 9.59016"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="hover-stroke"
        d="M12 14.6307C11.94 14.6207 11.87 14.6207 11.81 14.6307C10.43 14.5807 9.32996 13.4507 9.32996 12.0507C9.32996 10.6207 10.48 9.4707 11.91 9.4707C13.34 9.4707 14.49 10.6307 14.49 12.0507C14.48 13.4507 13.38 14.5907 12 14.6307Z"
        stroke={sideColor ? sideColor : color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="hover-stroke"
        d="M9.08997 17.7813C7.67997 18.7213 7.67997 20.2613 9.08997 21.2013C10.69 22.2713 13.31 22.2713 14.91 21.2013C16.32 20.2613 16.32 18.7213 14.91 17.7813C13.32 16.7213 10.69 16.7213 9.08997 17.7813Z"
        stroke={sideColor ? sideColor : color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CandidatesIcon;
